export default __webpack_public_path__ + "static/media/03.57e509c8.png";